<template>
  <div class="hello">
    <!-- ////////////// Header Start ////////////// -->
    <app-header></app-header>
    <!-- ////////////// Header End ////////////// -->
    <div class="info-box">
      <svg class="info-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
      <div class="info-text">
        Nous vous remercions de votre visite<br>A bientôt !
      </div>
    </div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'disconnect',
  data () {
    return {
      user_name: '',
      password: '',
      user: AppModules.getUser()
    }
  },
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  mounted: function () {
    AppModules.clearDefinitions()
    this.user.disconnect(this.$router, 2000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .hello {
    background-position: 0 50px;
    background-repeat: no-repeat;
    width: 733px;
    margin: auto;
  }

  .info-box {
    transition: opacity 0.8s ease;
    background: url(/static/images/info_msg.svg) top center no-repeat;
    width: 667px;
    height: 103px;
    text-align: left;
    position: absolute;
    top: 25vh;
    opacity: 1;
  }

  .info-text {
    text-align: center;
    color: var(--info-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 14px;
    height: 30px;
    display: inline-block;
    position: relative;
    width: 498px;
    height: 45px;
    top: calc(50% - (45px / 2));
    left: calc(50% - (498px / 2));
  }

</style>



// WEBPACK FOOTER //
// Disconnect.vue?7c753297